module.exports = __webpack_public_path__ + "static/media/test-accuracy.d0e19929.svg";